
<div class="mb-dialog-payment-method"> 
    <mb-dialog-header>
      <h3>Medios de pago</h3>
    </mb-dialog-header>
    <mb-dialog-body>
      <div class="content">
        <div class="container-paymethods"> 
          <div class="payment-method">
            <mb-icon class="icon" icon="bank-financing"></mb-icon>
            <div class="label">
              <p>Transferencia <br> en dólares</p>
            </div>
          </div>
          <div class="payment-method">
            <mb-icon class="icon" icon="bank-credit-card"></mb-icon>
            <div class="label">
              <p>Tarjeta de débito<br> en dólares</p>
            </div>
          </div>
        </div>

        <div class="legend">
          <mb-icon class="icon" icon="exclamation-circle"></mb-icon>
          <div class="text">
            <p><b>Ahorrá percepciones e impuesto país</b> pagando en dólares</p>
          </div>
        </div>
      </div>
    </mb-dialog-body>
</div>